import { Branch } from "@domain/CRM/branch";
import { Company } from "@domain/CRM/company";
import { StandardAxiosConfig } from "../../../common";
import { DataAPI_Base, GetAPI_Base, UpdateAPI_Base } from "../base";
import { apiClient } from "../../../client";

class GetAPI_Branches extends GetAPI_Base<Branch> {
	constructor() {
		super("branches", Branch);
	}

	public async byCompany(company: Company) {
		if (!company.branchIds || company.branchIds.length === 0) return [];
		const branches = await super.byIds(company.branchIds);
		return branches;
	}
}

class UpdateAPI_Branches extends UpdateAPI_Base<Branch> {
	constructor() {
		super("branches");
	}

	public async agrianOrganizationIds(id: string, value: string[]) {
		const url = `${this.baseUrl}/${id}/agrian-organization-id`;
		await apiClient.post(url, value, StandardAxiosConfig());
	}
}

export class BranchesAPI extends DataAPI_Base<Branch> {
	get: GetAPI_Branches;
	update: UpdateAPI_Branches;

	constructor() {
		super("branches", Branch);
		this.get = new GetAPI_Branches();
		this.update = new UpdateAPI_Branches();
	}
}
